module.exports = __webpack_public_path__ + "img/logo-clean.5ffc478f.jpg";